import React, {Fragment, useState, useEffect} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import UserService from '../../../../../services/user'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import MasterServices from '../../../../../services/master'
import useDebounce from '../../../../../utils/hooks/useDebounce'

import {dateFormat} from '../../../../../thesis-and-dissertations/helpers/helper'

type Props = {
  onChange?: (e: any) => void
  toggle: () => void
  getData: any
  editFormValue?: any
  loading?: boolean
}

const FormOther: React.FC<Props> = ({toggle, getData, editFormValue, loading}) => {
  const [submit, setSubmit] = useState(false)
  const [formValue, setFormValue] = useState<any>({})

  const [inputs, setInputs] = useState<any>([
    {
      name: 'alternative_email',
      label: 'Email Alternatif',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'wa_phone',
      label: 'No. Handphone Alternatif',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'fb',
      label: 'Facebook',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'twitter',
      label: 'Twitter',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'ig',
      label: 'Instagram',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'youtube',
      label: 'Youtube',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
  ])

  useEffect(() => {
    setFormValue({
      code_phone: editFormValue?.detail?.user_details_code_phone,
      phone: editFormValue?.detail?.user_details_phone,
      code_wa_phone: editFormValue?.detail?.user_details_wa_code_phone,
      wa_phone: editFormValue?.detail?.user_details_wa_phone,
      fb: editFormValue?.detail?.user_details_fb,
      ig: editFormValue?.detail?.user_details_ig,
      twitter: editFormValue?.detail?.user_details_twitter,
      youtube: editFormValue?.detail?.user_details_youtube,
      description: editFormValue?.detail?.user_details_description,
      gender: editFormValue?.detail?.user_details_gender,
      dob: editFormValue?.detail?.dob ? dateFormat(editFormValue?.detail?.dob) : null,
      alternative_email: editFormValue?.detail?.alternative_email,
      id_card_number: editFormValue?.detail?.user_details_id_card_number,
      tax_id_number: editFormValue?.detail?.user_details_tax_id_number,
    })
  }, [editFormValue])

  const onChange = (e: any) => {
    const {name, value} = e.target

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleSubmit = async (e: any) => {
    try {
      e?.preventDefault()
      setSubmit(true)
      await UserService.updateProfile(formValue).then(() => {
        toast.success(`Profile Berhasil Diperbarui`)
        toggle()
        getData()
      })
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row>{FormGenerator(inputs, formValue, onChange, onChange, loading)}</Row>
        <Modal.Footer>
          <Button className='btn btn-secondary btn-sm' onClick={toggle} disabled={submit}>
            Batalkan
          </Button>
          <Button className='btn btn-primary btn-sm' type='submit' disabled={submit || loading}>
            {submit ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </Form>
    </Fragment>
  )
}

export default FormOther
